export const resetPasswordKeys = {
  all: ['reset-password'] as const,
  validate: (ott?: string) =>
    [...resetPasswordKeys.all, 'validate', ott] as const,
};
